var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.channels && _vm.channels.length)?_c('div',{class:_vm.$style.section},[_c('BaseSection',{attrs:{"title":"Radio","padded":""}},[_c('ChannelDetailBlock',{attrs:{"channels":_vm.channels,"playlists":_vm.playlists,"display-minimal-version":""}})],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }